import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk'
import { localFeatureFlags } from '@/utils/localFeatureFlags'

type AppFlagSet = Record<string, unknown>

export function useAppFlags<T extends AppFlagSet = AppFlagSet>(): T {
  const launchDarklyFlags = useLaunchDarklyFlags<T>()

  return {
    ...launchDarklyFlags,
    ...localFeatureFlags,
  } as T
}
